export default class CanvasHistory {
  constructor(
    canvas,
    { onChange = () => {}, onDraw = () => {} },
    { stack = [], step = -1 }
  ) {
    this.stack = stack;
    this.step =
      step >= -1 && step < stack.length
        ? step
        : stack.length > 0
        ? stack.length - 1
        : -1;
    this.canvas = canvas;
    this.ctx = canvas.getContext("2d");
    this.onChange = onChange;
    this.onDraw = onDraw;
    this.init();
  }

  getSnapshot = () => {
    const sn = (wnd, t, step, arr) => {
      let ahead = arr.length - step - 1;
      let behind = step;
      let top = ahead > t ? t : ahead;
      let from = behind - wnd + 1 + top;
      from = from < 0 ? 0 : from;
      let to = from + wnd;
      let stack = arr.slice(from, to);
      let newStep = step - from;
      return { behind, ahead, from, to, stack, step: newStep };
    };

    const { stack, step } = sn(20, 3, this.step, this.stack);
    return { step, stack };
  };

  init = () => {
    if (this.step > -1 && this.stack.length > this.step) {
      this.onDraw(this.stack[this.step], null, true);
    } else {
      this.push(true);
    }
  };

  push = (silent = false) => {
    console.log('push')
    this.step++;
    if (this.step < this.stack.length) {
      this.stack.length = this.step;
    }
    const snapshot = this.canvas.toDataURL();
    this.stack.push(snapshot);
    this.onDraw(snapshot);
    if (!silent) {
      this.onChange(snapshot);
    }
  };

  undo = () => {
    if (this.step > 0) {
      this.step--;
      const snapshot = this.stack[this.step];
      this.onDraw(snapshot);
      this.onChange(snapshot);
    }
  };
  redo = () => {
    if (this.step < this.stack.length - 1) {
      this.step++;
      const snapshot = this.stack[this.step];
      this.onDraw(snapshot);
      this.onChange(snapshot);
    }
  };
  clear = () => {
    this.step = -1;
    this.stack.length = 0;
    this.onDraw(null, () => {
      this.push();
      this.onChange(this.stack[0]);
    });
  };
}
